var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch-theme",attrs:{"for":"switchTheme"},on:{"change":_vm.changeTheme}},[_c('input',{staticClass:"switch-theme__field",attrs:{"id":"switchTheme","type":"checkbox"}}),_c('span',{staticClass:"switch-theme__bullet switch-theme__bullet--rounded"})])
}
var staticRenderFns = []

export { render, staticRenderFns }